import { Alert } from '@f_general/alert';
import { callPlatformAPI } from '@f_utils/callPlatformAPI';
import { createContext, useContext, useState } from 'react';

type TMigrationContext = {
    openModal: boolean;
    loading: boolean;
    info: TInfo | null;
    setOpenModal: (openModal: boolean) => void;
    validateAccount: (email: string) => Promise<any>;
    migrationAccount: (key: string, data: TMigration) => Promise<any>;
};

type TUser = {
    email: string;
    firstName: string;
    lastName: string;
};

type TInfo = {
    email: string;
    firstName: string;
    lastName: string;
    position: string;
    workspaceName: string;
    users: TUser[] | null;
};

type TMigration = {
    firstName: string;
    lastName: string;
    position: string;
    phoneNumber: string;
    password: string;
    workspaceName: string;
    users: string[] | null;
};

const MigrationContext = createContext<TMigrationContext | null>(null);
const useMigrationContext = () => useContext(MigrationContext);

function MigrationProvider(props: any) {
    const [openModal, setOpenModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [info, setInfo] = useState<TInfo>(null);

    const validateAccount = async (email: string) => {
        setLoading(true);
        const result = await callPlatformAPI(`auth-migration/request/${email}`, 'get');
        if (result.data.isOk) {
            setInfo(result.data.result);
        } else {
            switch (result.data?.result?.error?.interiorError?.variantNumber) {
                case 1:
                    Alert({
                        type: 'error',
                        text: 'Пользователь с таким email уже существует',
                    });
                    break;
                case 2:
                    Alert({
                        type: 'error',
                        text: 'Пользователь с таким email ждет активации',
                    });
                    break;
            }
        }
        setLoading(false);
        return result.data;
    };

    const migrationAccount = async (key: string, data: TMigration) => {
        setLoading(true);
        const result = await callPlatformAPI(`auth-migration/migration/${key}`, 'post', data);
        console.log('RES M', result.data);
        if (result.data.isOk) {
            Alert({
                type: 'success',
                text: 'Аккаунт успешно перенесен',
            });
        } else {
            if (result.data?.result?.error?.interiorError?.variantNumber) {
                switch (result.data?.result?.error?.interiorError?.variantNumber) {
                    case 1:
                        Alert({
                            type: 'error',
                            text: 'Пользователь с таким email уже существует',
                        });
                        break;
                    case 2:
                        Alert({
                            type: 'error',
                            text: 'Пользователь с таким email ждет активации',
                        });
                        break;
                }
            } else {
                Alert({
                    type: 'error',
                    text: 'Ошибка при переносе аккаунта, Заявка направлена в поддержку. В скором времени с вами свяжутся.',
                });
            }
        }
        setInfo(null);
        setLoading(false);
        return result.data;
    };

    return (
        <MigrationContext.Provider
            value={{
                openModal,
                loading,
                info,
                migrationAccount,
                setOpenModal,
                validateAccount,
            }}
            {...props}
        />
    );
}

export { MigrationProvider, useMigrationContext };
